/*
 * @Description:
 * @Author: fal
 * @Date: 2025-03-17 16:23:26
 * @FilePath: \pc.ui\src\project\utils\validation.js
 * @LastEditTime: 2025-03-17 16:30:23
 */
/**
 * 校验是否为数字，最多保留 n 位小数（必须大于0）
 * @param {string|number} value 要校验的值
 * @param {number} n 保留的小数位数
 * @returns {boolean} 校验结果
 */
export function isValidNumber(value, n) {
  if (value < 0) return false;
  const regex = n === 0 ? /^-?\d+$/ : new RegExp(`^-?\\d+(\\.\\d{1,${n}})?$`);
  return regex.test(value);
}

/**
 * 校验是否为数字，最多保留 n 位小数（可以小于0）
 * @param {string|number} value 要校验的值
 * @param {number} n 保留的小数位数
 * @returns {boolean} 校验结果
 */
export function isValidNumber2(value, n) {
  const regex = n === 0 ? /^-?\d+$/ : new RegExp(`^-?\\d+(\\.\\d{1,${n}})?$`);
  return regex.test(value);
}

/**
 * 校验手机号
 * @param {string} phone 要校验的手机号
 * @returns {boolean} 校验结果
 */
export function isValidPhoneNumber(phone) {
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(phone);
}

/**
 * 校验身份证号
 * @param {string} idCard 要校验的身份证号
 * @returns {boolean} 校验结果
 */
export function isValidIDCard(idCard) {
  const regex = /^(?:\d{15}|\d{17}[\dXx])$/;
  return regex.test(idCard);
}
